module.exports = __webpack_public_path__ + "img/flower-bike.fd896f9f.jpeg";